import MultiLanguageDesignationModel from './MultiLanguageDesignationModel';
import MultiLanguageField from './MultiLanguageField';
import * as AT from '../../components/container/attributes';
import BaseModel from './BaseModel';

export default class Competence extends MultiLanguageDesignationModel {
  constructor({
    id,
    number,
    designationFrBe = undefined,
    designationDeBe = undefined,
    designationNlBe = undefined,
    designationFrLu = undefined,
    designationDeLu = undefined,
    designationFrFr = undefined,
    designationDeDe = undefined,
    designationNlNl = undefined,
    designationEnGb = undefined,
    designationEnIn = undefined,
    designationMrIn = undefined,
    designationHiIn = undefined,
    descriptionFrBe = undefined,
    descriptionDeBe = undefined,
    descriptionNlBe = undefined,
    descriptionFrLu = undefined,
    descriptionDeLu = undefined,
    descriptionFrFr = undefined,
    descriptionDeDe = undefined,
    descriptionNlNl = undefined,
    descriptionEnGb = undefined,
    descriptionEnIn = undefined,
    descriptionMrIn = undefined,
    descriptionHiIn = undefined,
  }) {
    super({
      id,
      number,
      designationFrBe,
      designationDeBe,
      designationNlBe,
      designationFrLu,
      designationDeLu,
      designationFrFr,
      designationDeDe,
      designationNlNl,
      designationEnGb,
      designationEnIn,
      designationMrIn,
      designationHiIn,
    });
    this.descriptions = new MultiLanguageField({
      descriptionFrBe,
      descriptionDeBe,
      descriptionNlBe,
      descriptionFrLu,
      descriptionDeLu,
      descriptionFrFr,
      descriptionDeDe,
      descriptionNlNl,
      descriptionEnGb,
      descriptionEnIn,
      descriptionMrIn,
      descriptionHiIn,
    });
    this.description = this.descriptions.value;
  }

  static get config() {
    const config = BaseModel.config;
    config['browsable'] = true;
    return config;
  }
  get config() {
    return Competence.config;
  }

  static get orderKey() {
    return 'number';
  }

  static get orderKeyEmbedded() {
    return 'number';
  }

  static get joinFilterColumns() {
    return ['designation'];
  }

  static get fkName() {
    return "competence_id";
  }
  static get apiRoute() {
    return 'competence';
  }
  static get listPageRoute() {
    return 'competenceList';
  }
  static get detailPageRoute() {
    return 'competenceDetail';
  }
  static get createInitColumns() {
    return {};
  }
  get fkName() {
    return Competence.fkName;
  }
  get apiRoute() {
    return Competence.apiRoute;
  }
  get detailPageRoute() {
    return Competence.detailPageRoute;
  }
  get listPageRoute() {
    return Competence.listPageRoute;
  }
  get createInitColumns() {
    return Competence.createInitColumns;
  }

  static get defaultSort() {
    return {
      property: 'number',
      order: 'asc',
    };
  }

   static get listDisplayAttrs() {
    return this.getAttributes([
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
    ]);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
        [
          'number',
          this.attributeUserLocale('designation'),
          this.attributeCompanyLocale('designation'),
        ],
        [
          'number',
          this.attributeUserLocale('description'),
          this.attributeCompanyLocale('description'),
        ]
    );
  }

  static get joinAttrsKey() {
    return [
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      this.attributeUserLocale('description'),
      this.attributeCompanyLocale('description'),
    ];
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE({}, {maxWidth: '1fr'}),
    ]
        .concat(
            this.generateMultiLanguageField({
              key: 'designation',
              attributeClass: AT.StringAttribute,
              header: 'hit-base.common.designation',
            })
        )
        .concat(
            this.generateMultiLanguageField({
              key: 'description',
              attributeClass: AT.RichTextAttribute,
              header: 'hit-base.common.description',
            })
        );
  }
}
